import { gateway } from "../../../../gateway";

export async function resendActivationAction(payload) {
  const response = await gateway.post("/users/resend-activation", payload);
  return response.data;
}